import { bloomFragmentProperty } from "../../property/resource/bloom-fragment-property";
import { ResourceColumn } from "../planner-column";

export const bloomFragmentColumn = new ResourceColumn(
  'Bloom Fragments',
  'stl_limit_break_item_2_cropped.png',
  'bloomFragments',
  bloomFragmentProperty,
)
